import { Injectable } from '@angular/core';
import { SocketService } from './socket.service';
import { Observable } from 'rxjs';
import { AuthenticationService, TokenInterface } from '../../core/services';
import { finalize, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SocketExportService {
  constructor(
    private readonly socketService: SocketService,
    private readonly authenticationService: AuthenticationService
  ) {
  }

  export<T extends Object>(action: string, payload: T) {
    return this.authenticationService.getToken().pipe(
      switchMap((token: TokenInterface) => {
        return new Observable((observer) => {

          this.socketService.connect();
          this.socketService.sendMessage({
            action,
            auth: `${token.key} ${token.value}`,
            payload,
          });
          this.socketService.onMessage(action).subscribe({
            next: (data) => {
              observer.next(JSON.parse(data?.body));
              observer.complete();
              this.socketService.disconnect();
            },
            error: (err) => {
              observer.error(err);
              observer.complete();
              this.socketService.disconnect();
            },
          });
        })
      }),
      finalize(() => this.socketService.disconnect()),
    )
  }
}
